import React from 'react'
import { PageProps } from 'gatsby'

// Lazy loading
import loadable from '@loadable/component'

export interface FormProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Form
  location: PageProps['location']
}

interface PostProps {
  [key: string]: any
}

const FormShell: React.FC<FormProps> = ({ fields, location }) => {
  const types: PostProps = {
    contact: loadable(() => import('components/flex/Form/FormContact')),
    vacancy: loadable(() => import('components/flex/Form/FormVacancy')),
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default FormShell
